// components/ui/LedgerRow.tsx
// Tabular row for the estate schedule / tax calculation / allowance breakdown.
// Dotted rule under each row, mono numerics, right-aligned values.

import React from 'react';

interface LedgerRowProps {
    label: React.ReactNode;
    value: React.ReactNode;
    emphasis?: 'none' | 'subtotal' | 'total';
    muted?: boolean;
    indent?: boolean;
}

export function LedgerRow({ label, value, emphasis = 'none', muted = false, indent = false }: LedgerRowProps) {
    const borderClass =
        emphasis === 'total'
            ? 'border-t border-[#1A1A1A]'
            : emphasis === 'subtotal'
            ? 'border-t border-[#E8E4DB]'
            : 'border-b border-dotted border-[#E8E4DB]';

    const valueClass =
        emphasis === 'total'
            ? 'font-mono text-[15px] text-[#1A1A1A] font-semibold tabular-nums'
            : emphasis === 'subtotal'
            ? 'font-mono text-[13px] text-[#1A1A1A] font-semibold tabular-nums'
            : muted
            ? 'font-mono text-[13px] text-[#6B6762] tabular-nums'
            : 'font-mono text-[13px] text-[#1A1A1A] tabular-nums';

    const labelClass =
        emphasis === 'total' || emphasis === 'subtotal'
            ? 'text-[13px] text-[#1A1A1A] font-semibold'
            : muted
            ? 'text-[13px] text-[#6B6762]'
            : 'text-[13px] text-[#3F3D39]';

    const emphasisClass = emphasis !== 'none' ? emphasis : '';

    return (
        <div className={`ledger-row ${emphasisClass} flex items-center justify-between py-2.5 ${borderClass} ${indent ? 'pl-4' : ''}`}>
            <span className={`label ${labelClass}`}>{label}</span>
            <span className={`value ${valueClass}`}>{value}</span>
        </div>
    );
}
